import React from 'react';
import { List, Datagrid, TextField, EmailField } from 'react-admin';

const AppList = props => (
    <List 
    	{...props}
    	title="Apps"
    >
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
        </Datagrid>
    </List>
);

export default AppList;
